import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { store } from './store/main';
import indexStyles from './index.css?url';
import pixelStyles from '@brandlive/pixel/pixel.css?url';

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Sign into Brandlive</title>
        <link rel="stylesheet" href={pixelStyles} />
        <link rel="stylesheet" href={indexStyles} />

        <style
          dangerouslySetInnerHTML={{
            __html: `
          @font-face {
            font-family: "Outfit";
            src: url("https://assets.brandlive.com/assets/fonts/css/Outfit-VariableFont_wght.ttf") format("truetype-variations");
            font-display: swap;
            font-style: normal;
          }
          @font-face {
            font-family: "Lexend";
            src: url("https://assets.brandlive.com/assets/fonts/css/Lexend-VariableFont_wght.ttf") format("truetype-variations");
            font-display: swap;
            font-style: normal;
          }
          @font-face {
            font-family: "TASAOrbiter";
            src: url("https://assets.brandlive.com/assets/assets/fonts/css/TASAOrbiter-VariableFont_wght.ttf") format("truetype-variations");
            font-display: swap;
            font-style: normal;
          }
        `,
          }}
        />
        <Meta />
        <Links />
      </head>
      <body>
        <HelmetProvider>
          <Provider store={store}>{children}</Provider>
        </HelmetProvider>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function Root() {
  return <Outlet />;
}
